<template>
    <div class="wrap" style="margin:0 -12px;">
        <div class="container">
            <div class="row">
                <div class="col">
                    <div style="padding:0 10px;">
                        <br>
                        <a href="/event/entry/question3" style="font-size:12px;text-decoration:none;">
                            <svg style="height:12px;width:12px;fill:#6B4EFF;margin-top:-2px">
                                <use xlink:href="/images/<.svg#page_left"></use>
                            </svg>&nbsp;前のフォームに戻る</a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col px-0">
                    <hr style="background-color: #E6E6E6;">
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div style="padding:0 10px;">
                        <div style="font-size:10px;color:#444">
                            以下の内容をお読みいただき、同意のうえでご利用ください。
                        </div>
                        <br>
                        <div class="" style="color:#5538EE;font-size:20px">
                            <b>イベントを開催するにあたって<br>守るべきこと</b>
                        </div>
                        <br>
                        <div style="font-size:12px;padding:0 10px;">
                            【禁止する行為】<br>
                            ① 法律に違反をする行為(乱交/ハプバーなども禁止)<br>
                            ② 性的な写真ややり取りを強要する行為<br>
                            ③ 生命に関わる危険な行為<br>
                            ③ 宗教・ネットワークビジネス等の勧誘活動<br>
                            ※SMバーや各種SMイベントの集客にはご活用頂けます。<br>
                            <br>
                            <b style="color:red">禁止行為に当たるイベントは運営側で削除をいたします。</b>
                        </div>
                        <br>
                        <div @scroll="onScrollSomething" style="width: 100%;height:300px;overflow-y: scroll;"
                            id="modal-box">
                            <br>この規約（以下「本規約」といいます）は、株式会社Luna（以下「当社」といいます）が提供するLuna（ルナ）に関する全てのサービス（以下「本サービス」といいます）の利用に関する条件を、本サービスを利用するお客様（以下「利用者」といいます）と当社との間で定めるものです。
                            <br>
                            <br>
                            <h5>第1条（規約への同意）</h5>
                            本サービスをご利用になる前に、本規約を良くお読みください。
                            <br>利用者は、本規約の定めに従って本サービスを利用しなければなりません。
                            <br>利用者は、会員登録をしないかぎり本サービスを利用できません。
                            <br>利用者は会員登録をするにあたり、本規約に同意して頂くことが必要であり、会員登録が完了した時点で、本規約を内容とする本サービス利用契約（以下「本契約」といいます）が当社との間で締結されます。
                            <br>
                            <br>
                            <h5>第2条（規約の適用）</h5>
                            本規約の規定が利用者との本規約に基づく契約に適用される関連法令に反するとされる場合、当該規定は、その限りにおいて、
                            当該利用者との契約には適用されないものとします。但し、この場合でも、本規約の他の規定の効力には影響しないものとします。
                            <br>
                            <br>
                            <h5>第3条（本サービスの内容）</h5>
                            本サービスは、18歳以上（高校生は除く）の方のkinkyの嗜好を持つ人を対象とした、kinkyの嗜好を持つ人同士をつなぐこと、もしくはそのコミュニティをサポートするサービスです。
                            本サービスは、一部のサービスおよび機能を、無料でご利用いただけます。 なお、本サービスはkinkyの嗜好を持つ人同士のパートナー相手を見つけることを保証するものではありません。
                            <br>
                            <br>
                            <h5>第4条（定義）</h5>
                            本サービス利用規約において、次の用語はそれぞれ以下のように定義します。
                            <br>
                            <br>「コンテンツ」：本サービスを通じて利用者が入力した、プロフィールなど一切の情報。
                            <br>「利用者」：当社が定めた本サービスの登録手続きに従い、本規約に対し同意の上、本サービスの会員登録を完了し、本サービスを利用する資格を持つ個人をいいます。
                            <br>
                            <br>
                            <h5>第5条（本サービスの提供、無保証、変更および中止）</h5>
                            当社は、本サービスの提供を受けることができる利用者を、会員登録の有無、年齢、その他、 当社が合理的に必要と判断する条件を満たしたお客様に限定することができるものとします。
                            <br>当社は、当社が合理的に必要と判断する場合、 あらかじめ利用者に通知することなく、いつでも、本サービスの全部または一部の内容を変更し、また、その提供を中止することができるものとします。
                            当社は、本規定に基づき当社が行った措置によって利用者に生じた損害について一切の責任を負いません。
                            <br>当社は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、 正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、
                            権利侵害などを含みますが、これらに限りません）がないことを保証しておりません。
                            <br>当社は、本サービスが、全てのパソコン、スマートフォン、タブレット端末等およびOSに対応することを保証しておりません。また、当社は、利用者の環境により本サービスを利用できなかったことに基づき利用者に生じた損害について、一切の責任を負いません。
                            <br>
                            <br>
                            <h5>第6条（利用資格）</h5>
                            18歳以上（高校生は除く）の方のkinkyの嗜好を持つ人を対象とした、kinkyの嗜好を持つ人同士をつなぐこと、もしくはそのコミュニティをサポートするサービスです。年齢及びパートナーの有無の判断は、当社が会員登録時の本人の自己申告等を元に行うものであり、全ての本サービスの会員が常時18歳以上であることを当社が保証するものではありません。登録後に違反が発見された場合、当社判断で会員登録を無効とさせていただきます。当社は、無効とする措置により利用者に発生した損害について一切の責任を負わないものとします。
                            <br>当社は、利用者が会員登録情報の虚偽その他利用資格に疑義があると判断される場合、当該利用者に対し以下に定める措置の実施を求め、当該措置の実施により利用資格等につき確認ができるまでの間、会員登録を拒否し、または本サービスの利用を停止することができるものとします。当社は、これにより利用者に発生した損害について一切の責任を負わず、また、利用停止中の有料サービスの利用料金の返金もいたしません。
                            <br>利用者は、本サービスをご利用になることによって、本契約に参加し本契約の規約と条件の全てに従う権利、権限、義務および能力を有すると表明し、保証するとみなされます。
                            <br>本サービスは、会員の犯罪経歴調査は行っておらず、会員の経歴も問い合わせず、会員の申告も確認は行っていないため、他の利用者について、この点を当社が保証するものではない点をご理解してください。
                            <br>当社は、利用者について、いずれかの犯罪経歴調査や他の審査（例：性的犯罪者登録検索）を、いつでも、利用可能な公的記録を使用して、行うことができるものとしますが、これを行う義務を負うものではありません。
                            <br>本サービスは、現在または今後の会員の行為や整合性に関して、保証しておりません。
                            <ul>
                                <li>当社は、利用者が下記の事由に相当する場合は、会員登録の拒否を行うことが出来るものとします。</li>
                                <li>本規約に違反するおそれがあると当社が合理的に判断した場合</li>
                                <li>当社に提供された登録情報の全部又は一部につき虚偽、誤記又は記載漏れがあった場合</li>
                                <li>成年被後見人、被保佐人、又は被補助人のいずれかであり、法定代理人、後見人、保佐人又は補助人の同意等を得ていなかった場合</li>
                                <li>反社会的勢力等（暴力団、暴力団体、右翼団体、反社会的勢力、その他これに準ずる者を意味します。以下同じ。）である、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合
                                </li>
                                <li>その他、当社が登録を適当でないと合理的に判断した場合</li>
                            </ul>
                            利用者は、プロフィール情報に変更が生じた場合は、直ちに当社所定の方法により、プロフィール情報の変更を行うものとします。
                            <br>
                            <br>
                            <h5>第7条（利用者の責任および注意義務）</h5>
                            利用者は、自己の責任に基づき本サービスを利用するものとし、利用者が公開するコンテンツについて、全て自己で責任を負うものとします。
                            <br>利用者は当社に対し、他人の著作物を使用したことなどが原因で紛争、損害賠償の請求などが起こった場合の損害、責任について一切を免責するものとし、自らの責任をもって紛争に対処するものとします。
                            <br>利用者は、自己の責任において、Lunaアカウントを管理及び保管するものとし、これを第三者に利用させたり、貸与、譲渡、名義変更、売買等をしてはならないものとします。利用者は、当社に対し、Lunaアカウントを第三者に盗用されるなどにより、利用者のコンテンツの改変や改竄、個人情報等の無断閲覧などにより発生するあらゆる紛争、損害賠償の請求などについて一切を免責するものとします。
                            <br>利用者は、本サービス利用中に知り得た他の利用者に関する情報（他の利用者のプロフィール情報、投稿コンテンツに含まれる情報を含みますが、これらに限りません。以下「利用者情報」といいます）について、守秘義務を負うものとします。利用者は、これらの情報につき、本サービスの利用以外の目的での使用、第三者に対する開示または漏洩、当社の許可なく複製・複写のいずれもしてはならず、また、本サービスの利用終了後は、速やかに当該他の利用者のこれらの情報を破棄しなければなりません。
                            <br>利用者は、本条で定める行為において当社に損害を与えた場合は、当社が当該利用者に対して損害賠償を請求する権利を有することを認めます。
                            <br>当社は、以下のいずれかに該当する場合には、利用者に事前に通知することなく、本サービスの利用の全部又は一部を停止又は中断することができるものとします。
                            <ul>
                                <li>本サービスに係るコンピューター・システムの点検又は保守作業を定期的又は緊急に行う場合</li>
                                <li>コンピューター、通信回線等が事故により停止した場合</li>
                                <li>火災、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合</li>
                                <li>SNSログインサービスに、トラブル、サービス提供の中断又は停止、仕様変更等が生じた場合</li>
                                <li>ログインや決済等、サービスの重要な機能に障害が発生した場合</li>
                                <li>その他、当社が停止又は中断を必要と判断した場合</li>
                            </ul>
                            当社は、本条に基づき当社が行った措置に基づき利用者に生じた損害について一切の責任を負いません。
                            <br>
                            <br>
                            <h5>第8条（禁止事項）</h5>
                            利用者は、本サービスの利用に際して、以下の行為を行ってはならないものとします。利用者がこれらの禁止行為を行った、又は行うおそれがあると当社が合理的に判断した場合、利用者に通知することなく、当社は該当する内容のデータの削除、当該利用者に対して注意を促す表示を行う、または利用制限もしくは強制退会させることができるものとします。ただし、当社は、当該データ等を掲載停止または削除する義務を負うものではなく、データの削除および利用制限等の処分につきまして当社は説明の義務を負わないものとします。
                            利用者は、これらの禁止行為を行うことにより当社に損害を与えた場合は、当社が当該利用者に対して損害賠償を請求する権利を有することを認めます。
                            なお、当社は、本条に基づき当社が行った措置に基づき利用者に生じた損害について一切の責任を負いません。
                            <br>
                            <br>会員のアイコン画像、サブ写真を含む、本サービス上の画像を当社の承諾なくキャプチャーその他の方法により複製、利用又は公開する行為
                            <br>本規約に反する行為
                            <br>日本国または利用者に適用される国・地域の法令に違反する行為
                            <br>社会規範・公序良俗に反するものや、他人の権利を侵害し、または他人の迷惑となるようなものを、投稿、掲載、開示、提供または送信（以下これらを総称して「投稿など」といいます）したりする行為
                            <br>利用者以外の自然人・法人・団体・組織等の第三者（以下、「第三者」といいます）に自己のLunaアカウントを譲渡して、本サービスを利用させる行為
                            <br>第三者に自己のLunaアカウントのログインに必要な情報を閲覧可能な状態にしておく行為
                            <br>本サービスに関連して、反社会的勢力に直接・間接に利益を提供する行為
                            <br>本サービスを、提供の趣旨に照らして本来のサービス提供の目的とは異なる目的で利用する行為
                            <br>他の利用者を含む第三者の個人情報や利用者情報を第三者に開示または漏洩する行為
                            <br>本サービス利用中に知り得た他の利用者の利用者情報を、本サービスの利用以外の目的で使用する行為
                            <br>本サービス利用中に知り得た他の利用者の利用者情報を、当社の許可なく複製・複写する行為
                            <br>18歳未満（高校生を含む）の会員登録および本サービスの利用
                            <br>児童を騙る行為
                            <br>残酷な表現、犯罪を誘発する表現、差別表現など、公序良俗に反する行為やコンテンツ閲覧者
                            <br>第三者に成りすます行為
                            <br>虚偽の情報をコンテンツに掲載し、コンテンツ閲覧者を欺く行為
                            <br>第三者の名誉や社会的信用を毀損したり、不快感や精神的な損害を与える行為
                            <br>選挙運動、またはこれらに類似する行為および公職選挙法に抵触する行為
                            <br>コンテンツ閲覧者を含む利用者以外の自然人・法人・団体・組織等の第三者の個人情報の収集を行う行為
                            <br>当社、他の利用者またはその他の第三者の保有する著作権を含む知的財産権、肖像権その他一切の権利を侵害し、または侵害を誘発する行為
                            <br>当社が許可した場合を除く、本サービス上の文字、画像、会員のニックネーム、アイコン画像、サブ写真、プロフィール情報、自己紹介文、その他の会員の情報を無断で使用する行為（モザイク処理をしても、当社が許可をしていない場合は無断使用と見なします）
                            <br>本サービスの運営を妨げる行為
                            <br>当社が、本サービスの運営を妨げるおそれがあると判断する量のデータ転送、サーバーに負担をかける行為（不正な連続アクセスなど）
                            <br>金銭が発生する等の商用目的の宣伝・広告行為（例：他のサービスへの誘導を目的として特定または不特定多数の利用者にいいねを送信したり、そのURLを記載する行為や、貢ぎ行為や売春等またはそれに類する活動への誘導を目的として利用をする行為）
                            <br>有害なコンピュータウィルス、コード、ファイル、プログラム等を開示する行為、もしくは開示されている場所について示唆する行為
                            <br>無限連鎖講およびマルチ商法、またはそれに類するもの、その恐れのあるもの、あるいは当社が無限連鎖講およびマルチ商法、またはそれに類するもの、その恐れのあるものと判断する内容を掲載する行為
                            <br>児童ポルノ、またはそれに類する内容、あるいは当社が児童ポルノに類すると判断する内容を掲載する行為
                            <br>次のようなコンテンツを投稿などすること
                            <ul>
                                <li>許可を得ないで第三者のプロフィールや写真を使用したコンテンツ</li>
                                <li>集団および個人に対するあらゆる種類の人種差別や偏見、憎悪、身体的危害を助長するコンテンツのような、オンラインコミュニティーに対して明らかに不快だと思われるコンテンツ</li>
                                <li>他人への嫌がらせのコンテンツ、または嫌がらせを支持するコンテンツ</li>
                                <li>嘘であることや誤解を招くということを利用者がわかっている情報を広めるコンテンツや、違法行為を助長するコンテンツ、または罵倒、脅迫、わいせつ、名誉毀損、文書による名誉毀損に当たるような行為を助長するコンテンツ
                                </li>
                                <li>｢ジャンクメール｣、｢チェーンメール｣、迷惑メール、｢スパム｣などの送信に関連するコンテンツ</li>
                                <li>海賊版コンピュータ･プログラムを提供したり、それにリンクを張ったり、製品に組み込まれたコピー防止機能を回避する情報を提供したり、海賊版音楽を提供したり、海賊版音楽ファイルにリンクを張ったりするなどして、他人の著作権によって保護された作品を違法または不正にコピーすることを助長するコンテンツ
                                </li>
                                <li>性的または暴力的な手法で18歳未満の人を不当に利用するコンテンツ。または、18歳未満の人から個人情報を求める構成要素を提供するコンテンツ</li>
                                <li>営利的または違法な目的のために、他の利用者からパスワードや個人情報を求めるコンテンツ</li>
                                <li>違法な武器の製造、購入や、他人のプライバシーの侵害、コンピュータウィルスの製造など、違法行為に関する説明を提供するコンテンツ</li>
                                <li>公開されていないページや、パスワードがないとアクセスできないページを含んだコンテンツ</li>
                                <li>コンテスト、宝くじ、物々交換、宣伝、ネズミ講など、当社から事前に書面で許可を得ないで、営利的活動または販売を行うコンテンツ</li>
                            </ul>
                            その他当社が不適切であると判断する行為
                            <br>
                            <br>
                            <h5>第9条（本サービスの利用制限）</h5>
                            当社は、本サービス以外での利用者の行為を監視することができませんが、本サービスから得た情報を、他人に対する嫌がらせや罵倒、危害を加える目的で使用したり、事前に明示的な同意を相手から得ずに他の会員に連絡、宣伝、勧誘、販売したりすることも、本規約に対する違反になります。そのような宣伝や勧誘から当社の会員を守るために、利用者が他の会員に24時間以内に送ることができるいいねの数を、当社の妥当な判断で適切な数に制限する権利を当社は有します。
                            <br>
                            <br>
                            <h5>第10条（契約期間および契約の終了）</h5>
                            利用者が本サービスの会員である限り、本契約は有効です。会員になって本サービスに参加することを利用者が選ばれた場合は、本サービスを即座に開始することを利用者が選ばれたことになり、クーリングオフは認められません。
                            <br>利用者は本サービスの退会申請フォームから契約終了の通知を当社にお送りいただくことで、いつでもいかなる理由でも、利用者は会員資格を終了させることができます。退会については、退会申請フォームからご連絡ください。
                            <br>利用者が本契約の一つ以上の条項に違反した場合、また、そのおそれがあると当社が合理的に判断した場合、当社は事前の連絡なしに、いつでも利用者の会員資格を即座に終了させ、禁止するコンテンツを削除し、本サービスの利用を終了させることができます。さらに、利用者が本サービスの全部または一部にアクセスすることを、恒久的または一時的に当社は禁止することができます。
                            <br>会員登録が取り消しとなった場合、利用者が退会した場合、その他の理由により利用者が会員資格を失った場合または利用ができなかった場合、有料サービスについて利用者が購入された利用期間が終了しておらずまたは利用期間中利用できなかった期間が含まれていても、返金は致しかねます。
                            <br>利用者が会員資格を有したまま有料サービスを終了された場合、終了以前に利用者が購入された利用期間が残っていても、有料サービスの一切がご利用できなくなります。また、日割りでの返金も含め、返金は致しかねます。
                            <br>利用者が有料会員でない場合、（本サービスに最後に接続した日から数えて）6ヵ月以上本サービスを利用しなかった会員のアカウントを、本サービスは無効にすることができます｡
                            <br>
                            <br>
                            <h5>第11条（再利用の禁止）</h5>
                            利用者が、当社のサービスやそれらを構成するデータを、本サービスの提供目的を超えて利用した場合、当社は、それらの行為を差し止める権利ならびにそれらの行為によって利用者が得た利益相当額を請求する権利を有します。
                            <br>
                            <br>
                            <h5>第12条（無料会員と有料会員、および利用料金）</h5>
                            本サービスは、一部、もしくは全てのサービスおよび機能を、無料でご利用いただけます。
                            <br>
                            <br>お客様が申し込まれた有料サービスを利用期間の途中で利用休止またはご解約（解約は退会フォームからお願いいたします）された場合も、返金や未利用期間の日割り計算による精算は行っておりませんのでご注意ください。
                            <br>
                            <br>なお、有料サービスは利用者が自ら自動更新を停止しない限り、自動的に更新されます。
                            <br>
                            <br>
                            <h5>第13条（投稿などの削除、サービスの利用停止、アカウント削除について）</h5>
                            利用者が本サービスに投稿などしたコンテンツについて、お客様は単独で責任を負います。利用者が投稿した場合はいつでも、そのコンテンツが（a）正確かつ（b）本契約に違反せず、かつ（c）あらゆる点で誰にも害が及ばないことを、お客様は表明し保証したことになります｡
                            <br>
                            <br>当社は、提供するサービスを適正に運営するために、以下の場合にはあらかじめ通知することなく、データやコンテンツを削除したり、サービスの全部または一部の利用をお断りしたり、利用者のアカウントを削除したりするといった措置を講じることができるものとします。
                            <ul>
                                <li>利用者が本規約に定められている事項に違反した場合、もしくはそのおそれがあると当社が合理的に判断した場合</li>
                                <li>当社にお支払いいただく代金について支払の遅滞が生じた場合</li>
                                <li>本サービスの代金決済手段として指定されたクレジットカードや銀行口座の利用が停止された場合</li>
                                <li>利用者が破産もしくは民事再生の手続の申立てを受け、または利用者自らがそれらの申立てを行うなど、利用者の信用不安が発生したと当社が判断した場合</li>
                                <li>アカウントが反社会的勢力またはその構成員や関係者によって登録または使用された場合、もしくはそのおそれがあると当社が判断した場合</li>
                                <li>利用者が一定期間にわたってアカウントまたは特定のサービスを使用していない場合</li>
                                <li>その他、利用者との信頼関係が失われた場合など、当社と利用者との契約関係の維持が困難であると当社が判断した場合</li>
                            </ul>
                            <br>
                            <h5>第14条（当社に対する補償）</h5>
                            利用者は、利用者が法令または本規約に違反して本サービスを利用したことに起因して（かかる趣旨のクレームを第三者より当社が受けた場合を含みます）、当社が直接的もしくは間接的に何らかの損害、損失または費用負担（弁護士費用の負担を含みます）を被った場合、当社の請求にしたがって直ちにこれを賠償または補償しなければなりません。
                            <br>
                            <br>
                            <h5>第15条（利用者のデータおよびコンテンツの取扱い）</h5>
                            当社の本サービスの保守や改良などの必要が生じた場合には、当社は利用者が当社の管理するサーバーに保存しているデータを、本サービスの保守や改良などに必要な範囲で複製等することができるものとします。
                            <br>
                            <br>利用者が投稿などをしたコンテンツ（画像データ、テキストを含みますが、これらに限られません。以下「投稿コンテンツ」といいます）については、利用者または当該投稿コンテンツの著作権者に著作権が帰属します。投稿コンテンツについて、利用者は当社に対して、日本の国内外で無償かつ非独占的に利用（複製、上映、公衆送信、展示、頒布、譲渡、貸与、翻訳、翻案、出版を含みます）する権利を期限の定めなく許諾（サブライセンス権を含みます）したものとみなします。なお、利用者は著作者人格権を行使しないものとします。
                            <br>
                            <br>利用者が本サービスを利用して生成した投稿コンテンツについての著作権を除き、本サービスおよび本サービスに関連する一切の情報についての著作権およびその他知的財産権はすべて当社または当社がその利用を許諾した権利者に帰属し、利用者は無断で複製、譲渡、貸与、翻訳、改変、転載、公衆送信（送信可能化を含みます）、伝送、配布、出版、営業使用等をしてはならないものとします。
                            <br>
                            <br>当社は、投稿コンテンツの利用を、利用者自身を除く、他の利用者その他の第三者に許諾するものではなく、利用者は他の利用者の投稿コンテンツの権利を侵害する行為を行ってはならないものとします。また、利用者は投稿コンテンツをクロール等で自動的に収集、解析する行為も行ってはならないものとします。
                            <br>
                            <br>当社は、他の利用者の投稿コンテンツを利用したことによって利用者に生じた損害について、一切の保証をいたしません。また、利用者が他の利用者の投稿コンテンツを利用して利益を得た場合には、当社はその利益相当額の金員を請求できる権利を有するものとします。
                            <br>
                            <br>
                            <h5>第16条（連絡または通知）</h5>
                            利用者は、本利用規約に別段の定めがある場合を除き、当社への連絡はお問い合わせ先から行うものとします。当社は電話による連絡および来訪は受け付けておりません。
                            <br>
                            <br>
                            <h5>第17条（権利義務などの譲渡）</h5>
                            利用者は、本規約に基づくすべての契約について、その契約上の地位およびこれにより生じる権利義務の全部または一部を、第三者に譲渡または貸与することはできません。
                            <br>
                            <br>当社は本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務並びに利用者の登録情報その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、利用者は、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。
                            <br>
                            <br>
                            <h5>第18条（会員間の紛争）</h5>
                            利用者は、自己の責任に基づき本サービスを利用するものとし、本サービスの他の会員との交流に関しては、単独で責任を負うものとします。当社は、利用者と他の会員との間で起きた紛争を監視する権利を留保しますが、義務はありません。
                            <br>
                            <br>
                            <h5>第19条（プライバシー）</h5>
                            本サービスの使用には、当社のプライバシーポリシーも適用されます。会員が当社に提供した（機密性の高い個人情報も含む）個人情報は、当社のコンピュータに保存されます。興味や好み、閲覧のパターンについてのプロフィールを作成し、会員が本サービスに参加できるようにするために、当社がこの情報を利用することに、会員は同意するものとします｡
                            <br>
                            <br>
                            <h5>第20条（免責事項）</h5>
                            当社の債務不履行責任は、当社の故意または重過失によらない場合には免責されるものとします。
                            <br>
                            <br>なお、お客様との本規約に基づく当社のサービスのご利用に関する契約が消費者契約法に定める消費者契約に該当する場合、上記の免責は適用されないものとし、当社は、当社の故意・重過失に起因する場合を除き、通常生じうる損害の範囲内で、かつ、有料サービスにおいては代金額（継続的なサービスの場合は1か月分相当額）を上限として損害賠償責任を負うものとします。
                            <br>
                            <br>本サービスの構成要素は、あらゆる種類の条件、保証、またはその他の契約条件なしに、無保証で提供されます。したがって、この法的通知がなければ本サービスとの関係で効力を持った可能性のあるすべての説明、保証、条件、またはその他の契約条件（満足のゆく品質、目的適合性、合理的な配慮と技術の行使など、法によって暗示されている条件を含みますが、これに限られません）を法によって認められている最大限度まで本サービスは排除するという前提で、当社は本サービスをお客様に提供します。
                            <br>
                            <br>当社や当社のパートナー企業、会員やその他の個人または団体が、本サービスを通じて表示し、アップロードし、または配布する助言、意見、声明やその他の情報について、当社はその正確さや信頼性を表明し保証するものではありません。以上のような意見、会員プロフィール、助言、声明や情報を信頼することについては、お客様の自己責任になることをお客様は承認するものとします。オンラインでもオフラインでも、会員の行動について当社は責任を負いません。本サービスを利用される際は、注意をして常識を働かせてください。適用法令の下で排除することが不可能な強行法規の権利（消費者としてのお客様の実定法上の権利を含みます）を、この法的通知および以上の免責事項は排除するものではありません。
                            <br>
                            <br>
                            <h5>第21条（本サービスのご利用上の注意）</h5>
                            本サービスは18歳以上（高校生は除く）の方のkinkyの嗜好を持つ人を対象とした、kinkyの嗜好を持つ人同士をつなぐこと、もしくはそのコミュニティをサポートするサービスですが、
                            不特定多数の方がご利用になっているため、場合によっては本サービスを悪用されたりする可能性があります。そのような可能性があることをご認識のうえ、
                            他の会員（特にマッチング後のメッセージのやり取りを行う他の会員）に対してのやりとり方法、個人情報の開示に関しては、慎重に考えて、本サービスをご利用ください。また、やり取りをしている会員が18歳以上かについては、ご本人の自己申告による情報等を元に判断しております。そのため、全ての会員様が18歳以上であることを保証するものではございません。他の会員に対して、個人情報等重要な情報の開示を行う場合は、慎重に検討し自己の責任のうえで行うようにしてください。規約違反の疑いがある会員を発見した場合は、すみやかに違反報告ボタン、またはお問い合せより違反内容をご報告ください。
                            <br>利用者は、当社が連携するSNSのバグ、不具合、瑕疵等について一切の責任を負わないことに予め同意するものとします。
                            <br>利用者は、連携するSNSの仕様、サービス内容その他の事項が変更されることにより、本サービスの内容や機能が変更される場合があることに予め同意するものとします。当社は、かかる変更により利用者に発生した損害について一切の責任を負わないものとします。
                            <br>利用者は、本サービスにてマッチングをした後、法律に違反をするような行為をすることはお控えください。(例：同意のない暴力行為や、性行為、刃物を使った医師法へ抵触する可能性がある行為など)
                            <br>
                            <br>
                            <h5>第22条（本サービス及び利用規約の変更について）</h5>
                            当社が必要と判断した場合には、利用者の事前の承諾を得ることなく、本規約をいつでも変更することができるものとします。なお、改定に際しては随時、利用者に告知するものとします。本規約変更後に、利用者が本サービスをご利用される場合には、変更後の本規約の内容を承諾したものとみなします。
                            <br>
                            <br>
                            <h5>第23条（準拠法）</h5>
                            本規約は、日本法に準拠し、解釈されるものとします。
                            <br>
                            <br>
                            <h5>第24条（管轄裁判所）</h5>
                            利用者と当社との間で訴訟の必要が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします
                            <br>
                            <br>発効日：2022年7月8日
                            <br>
                            <br>改定：2023年9月1日
                            <br>
                            <br>
                            <a id="endpos"></a>

                        </div>
                        <br>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col px-0">
                    <hr style="background-color: #E6E6E6;">
                    <br />
                    <div class="text-center" style="color:#6B4EFF;font-size:13px;padding:20px 0;">
                        最後までご確認のうえ、お進みください
                    </div>
                    <div class="d-grid gap-2">
                        <button type="button" class="btn btn-luna disabled" style="padding: 12px 0;border-radius: 0;"
                            v-if="is_load">
                            <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status" v-if="is_load">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            確認画面へ
                        </button>
                        <button type="button" class="btn btn-luna" style="padding: 12px 0;border-radius: 0;"
                            @click="setEvent()" id="on-btn" v-else-if="is_entry">
                            確認画面へ
                        </button>
                        <button type="button" class="btn btn-luna-d disabled"
                            style="background:#E7E7FF;border:0;padding: 12px 0;border-radius: 0;" id="non-btn" v-else>
                            確認画面へ
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            customer_mail: "",
            customer_mail_conf: "",
            is_load: false,
            is_entry: false,
            event_info: {},
        };
    },
    methods: {
        initEvent() {
            if (localStorage.getItem('luna_event_entry') !== null) {
                let serializedArray = localStorage.getItem('luna_event_entry');
                let event = JSON.parse(serializedArray);

                this.event_info = event
            }
        },
        rmEventInfo() {
            if (localStorage.getItem('luna_event_entry') !== null) {
                localStorage.removeItem('luna_event_entry')
            }
        },
        setEvent() {
            window.location.href = "/event/entry/question5"
        },
        async isAuth() {
            await axios.get("/api/auth/user/get")
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        onScrollSomething(event) {
            console.log("l")
            if (this.isFullScrolled(event)) {
                // 一番下までスクロールした際の処理
                this.is_entry = true
            }
        },
        isFullScrolled(event) {
            const adjustmentValue = 60
            const positionWithAdjustmentValue =
                event.target.clientHeight + event.target.scrollTop + adjustmentValue
            return positionWithAdjustmentValue >= event.target.scrollHeight
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.isAuth()
                            this.initEvent()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.isAuth()
                this.initEvent()
            }
        }
        else {
            this.isAuth()
            this.initEvent()
        }
    },
};

</script>

<style scoped>
small {
    color: #5538EE;
}

.select_sex {
    border: 0px;
}

.vs__dropdown-toggle {
    border-top: 0px;
    border-right: 0px;
    border-left: 0px;
    border-bottom: 1px solid #ced4da;
    border-radius: 0;
}

.vs__selected-options {
    color: #cdcfd0;
}

.sub_windows {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 111;
}

.croppa-container {
    background-color: #fff;
    border-radius: 8px;
}

.luna-search-bar {
    padding: 8px 12px 10px 12px;
    background-color: #fff;
    border-radius: 5px;
    color: #333333;
}


.luna-search-select-bar {
    padding: 8px 12px 10px 12px;
    background-color: #f0f0ff;
    border-radius: 5px;
    color: #000000;
}

.link_1 {
    color: #5538EE;
    text-decoration: underline;
}

.link_1:hover {
    color: #5538EE;
}

.link_1:link {
    color: #5538EE;
}

.link_1:visited {
    color: #5538EE;
}
</style>
